






























export default {
    props: {
        title: { type: String, default: 'arrow up icon' },
		fill:  { type: String, default: 'currentColor' },
		secondaryfill: { type: String, default: '' }
    }
}
